// いつでも変更して大丈夫です
// ただし、何をどう変更したいのかをdiscodeで伝えて欲しいです
// 他のコンポーネントで使用していることがあります

export const MemberList = [
  {
    address: 'abcde@gmail.com',
    name: 'abcde',
    src: 'https://cdn.discordapp.com/attachments/1038862997998817350/1051063658718957598/study_neko.PNG',
  },
  {
    address: '1234@gmail.com',
    name: '1234',
    src: 'https://cdn.discordapp.com/attachments/1038862997998817350/1051063653299916820/solo_neko.PNG',
  },
  {
    addres: 'aiueo@gmail.com',
    name: 'aiueo',
    src: 'https://cdn.discordapp.com/attachments/1038862997998817350/1051063655187353610/free_neko.PNG',
  },
  {
    addres: 'qwer@gmail.com',
    name: 'qwer',
    src: 'https://2.bp.blogspot.com/-4cDI5-IdyKs/WUdY336_nbI/AAAAAAABFAg/xxpZDJEt6ncUrMQwU7Ug-HQA8-eRI36eACLcBGAs/s400/pet_cat_sit.png',
  },
]

export const ScheduleWeek = [
  {
    start: '2023-05-21T13:00:00+09:00',
    end: '2023-05-21T18:00:00+09:00',
  },
  {
    start: '2023-05-22T13:00:00+09:00',
    end: '2023-05-22T14:00:00+09:00',
  },
  {
    start: '2023-05-23T3:00:00+09:00',
    end: '2023-05-23T8:00:00+09:00',
  },
]

export const ScheduleMonth = [
  {
    start: '2023-05-01T13:00:00+09:00',
    end: '2023-05-01T18:00:00+09:00',
  },
  {
    start: '2023-05-02T13:00:00+09:00',
    end: '2023-05-02T14:00:00+09:00',
  },
  {
    start: '2023-05-12T3:00:00+09:00',
    end: '2023-05-12T8:00:00+09:00',
  },
  {
    start: '2023-05-21T13:00:00+09:00',
    end: '2023-05-21T18:00:00+09:00',
  },
  {
    start: '2023-05-22T13:00:00+09:00',
    end: '2023-05-22T14:00:00+09:00',
  },
  {
    start: '2023-06-23T3:00:00+09:00',
    end: '2023-06-23T8:00:00+09:00',
  },
]

export const MonthSchedule = [
  87, 42, 15, 73, 91, 3, 66, 27, 58, 99, 7, 51, 68, 11, 94, 36, 80, 20, 62, 98,
  84, 6, 95, 30, 76, 43, 59, 2, 47, 9, 49,
]

export const Friend = 4
//フレンドの数

export const WeekTF = [
  {
    day: 0,
    work: [
      true,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      true,
      true,
      false,
    ],
  },
  {
    day: 1,
    work: [
      false,
      true,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      true,
      true,
    ],
  },
  {
    day: 2,
    work: [
      true,
      false,
      true,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      true,
    ],
  },
  {
    day: 3,
    work: [
      true,
      true,
      false,
      true,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
    ],
  },
  {
    day: 4,
    work: [
      true,
      true,
      true,
      false,
      true,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
    ],
  },
  {
    day: 5,
    work: [
      false,
      true,
      true,
      true,
      false,
      true,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
    ],
  },
  {
    day: 6,
    work: [
      true,
      false,
      true,
      true,
      true,
      false,
      true,
      true,
      false,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      true,
      false,
      true,
      false,
      false,
      true,
    ],
  },
]
